import React from 'react';
import { UserGroupIcon } from '@heroicons/react/24/outline';

const Participants: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Participants</h1>
      <p className="section-description">
        Manage event participants, track their registration status, and handle participant information.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <UserGroupIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Participant Management</h3>
              <p className="feature-description">
                Handle participants with the following capabilities:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Create and edit participant records</li>
                <li>Update participant status (Pending, Confirmed, Cancelled)</li>
                <li>Delete individual participants</li>
                <li>Bulk delete multiple participants</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <UserGroupIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Participant Details</h3>
              <p className="feature-description">
                Comprehensive participant information management:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Member selection (searchable)</li>
                <li>Event selection (searchable)</li>
                <li>Order ID association</li>
                <li>Status management</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <UserGroupIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Participant List</h3>
              <p className="feature-description">
                View and manage participants in a table format with the following columns:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Member name (searchable, sortable)</li>
                <li>Event name (searchable, sortable)</li>
                <li>Order ID (searchable, sortable)</li>
                <li>Status (color-coded badges)</li>
                <li>Creation date (sortable)</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <UserGroupIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Status Management</h3>
              <p className="feature-description">
                Track and manage participant status:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Pending (yellow badge)</li>
                <li>Confirmed (green badge)</li>
                <li>Cancelled (red badge)</li>
                <li>Filter participants by status</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Regularly update participant status to reflect current state</li>
            <li>Verify participant information against order details</li>
            <li>Keep accurate records of participant status changes</li>
            <li>Use status filters to manage participant groups effectively</li>
            <li>Maintain clear communication with participants about their status</li>
            <li>Regularly review and update participant information</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Participants; 